var _circle, _circle2, _circle3, _circle4, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizardBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7488,
    cy: 24.4167,
    r: 18.4167,
    fill: "url(#paint0_linear_1122_10763)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1122_10763)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7807,
    cy: 23.6167,
    r: 10.6167,
    fill: "url(#paint1_radial_1122_10763)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7807,
    cy: 23.6167,
    r: 10.6167,
    fill: "url(#paint2_radial_1122_10763)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7807,
    cy: 23.6167,
    r: 10.6167,
    fill: "url(#paint3_linear_1122_10763)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7807,
    cy: 23.6167,
    r: 11.6375,
    stroke: "url(#paint4_linear_1122_10763)",
    strokeWidth: 2.04167
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9904,
    cy: 23.6583,
    r: 12.7604,
    stroke: "white",
    strokeWidth: 0.204167
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1122_10763",
    x: 15.1211,
    y: 10.9583,
    width: 25.3164,
    height: 25.3167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.358333 0 0 0 0 0.0840788 0 0 0 0 0.0627083 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1122_10763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_10763",
    x1: 27.7488,
    y1: 6,
    x2: 27.7488,
    y2: 42.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C35A2A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1122_10763",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7807 23.6167) rotate(90) scale(16.5375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C67341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1122_10763",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0849 19.7375) rotate(-44.2462) scale(10.9729 5.82406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28787",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1122_10763",
    x1: 27.7807,
    y1: 13,
    x2: 27.7807,
    y2: 34.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1122_10763",
    x1: 27.7807,
    y1: 13,
    x2: 27.7807,
    y2: 34.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBC8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardBadge);
export default __webpack_public_path__ + "static/media/WizardBadge.5ff865078140211b6c746b2b7e5956d4.svg";
export { ForwardRef as ReactComponent };